//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import env from '../env.js'
export default {
    created () {
        this.getBaseInfo()
        this.initTimer()
    },
    mounted: function () {
        this.height = (window.innerHeight + 34) + 'px'
        this.$nextTick(function () {
            this.height = (window.innerHeight + 34) + 'px'
        })
    },
    data () {
        return {
            flag: true,
            height: '',
            result: {
                disinfectionMethod: '',
                createdAt: '',
                positionName: ''
            },
            monthDate: '',
            hoursMinute: ''
        }
    },
    methods: {
        initTimer () {
            this.getTime()
            setInterval(this.initTimer, 1000)
            this.clear()
        },
        clear () {
            clearInterval(this.initTimer)
            this.initTimer = null
        },
        // 获取消杀明细
        getBaseInfo () {
            let that = this
            let data = {}
            data.positionCode = this.$route.params.id
            this.$http({ url: env.javaUrl + 'disinfection/query-disinfection-record', data, method: 'POST' }).then(function (response) {
                if (response.data.status === 'ok') {
                    if (response.data.content.record && response.data.content.record.id) {
                        that.result = { ...response.data.content.record }
                    } else {
                        // that.$dialog.alert({
                        //     title: '提示',
                        //     message: '该区域暂无消杀记录'
                        // }).then(() => {
                        //     // on close
                        // })
                        that.flag = false
                    }
                } else if (response.data.status === 'err') {
                    that.$dialog.alert({
                        title: '提示',
                        message: response.data.message
                    }).then(() => {
                        // on close
                    })
                }
            }, function (response) {
                that.$dialog.alert({
                    title: '提示',
                    message: 'disinfection/query-disinfection-record接口异常'
                }).then(() => {
                    // on close
                })
            })
        },
        getTime () {
            var date = new Date()
            var month = date.getMonth() + 1
            var day = date.getDate()
            var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
            var minute = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
            var second = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
            this.monthDate = month + '月' + day + '日'
            this.hoursMinute = hours + ':' + minute + ':' + second
        }
    }
}



// WEBPACK FOOTER //
// ./src/view/home.vue